import { gql } from '@apollo/client';

export const BLOCKED_USER_FRAGMENT = gql`
  fragment BlockedUserFragment on BlockedUser {
    id
    ownerId
    ownerType
    userId
    blockedUserRole
    blockedByUserId
    clientId
    tenantId
    reason
    createdAt
  }
`;

export const GET_BLOCKED_USERS_FOR_OWNER = gql`
  ${BLOCKED_USER_FRAGMENT}
  query GetBlockedUsersForOwner(
    $ownerId: String!
    $ownerType: BlockedUserOwnerType!
    $blockedUserRole: UserRole
  ) {
    getBlockedUsersForOwner(
      ownerId: $ownerId
      ownerType: $ownerType
      blockedUserRole: $blockedUserRole
    ) {
      ...BlockedUserFragment
    }
  }
`;

export const BLOCK_USER = gql`
  ${BLOCKED_USER_FRAGMENT}
  mutation BlockUser(
    $ownerId: String!
    $ownerType: BlockedUserOwnerType!
    $userId: String!
    $reason: String
  ) {
    blockUser(
      ownerId: $ownerId
      ownerType: $ownerType
      userId: $userId
      reason: $reason
    ) {
      ...BlockedUserFragment
    }
  }
`;

export const UNBLOCK_USER = gql`
  mutation UnblockUser(
    $ownerId: String!
    $ownerType: BlockedUserOwnerType!
    $userId: String!
  ) {
    unblockUser(ownerId: $ownerId, ownerType: $ownerType, userId: $userId)
  }
`;
